/**
 * @generated SignedSource<<990cde41a98134ad2d04995d1d8f96b7>>
 * @relayHash 07e8208a5a79cc9c6018a8b034acefa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 396700da3fad9ac32c12f172fa3e68247b4f64f8d09df685def0dcb4ea6c324a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "396700da3fad9ac32c12f172fa3e68247b4f64f8d09df685def0dcb4ea6c324a",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
